module.exports = __webpack_public_path__ + "img/sleeve_length.8b40173e.png";